import React from 'react'

import { Disclosure } from '@cred/react-disclosures-sdk'

const disclaimers = {
  'citizens-bank': (
    <Disclosure
      required={false}
      slug="partners-widgets.student-loan-refi.disclaimer.citizens-bank"
    />
  ),
  cas: <Disclosure required={false} slug="partners-widgets.student-loan-refi.disclaimer.cas" />,
  invested: (
    <Disclosure required={false} slug="partners-widgets.student-loan-refi.disclaimer.invested" />
  ),
  elfi: <Disclosure required={false} slug="partners-widgets.student-loan-refi.disclaimer.elfi" />,
  mefa: <Disclosure required={false} slug="partners-widgets.student-loan-refi.disclaimer.mefa" />,
  edvestinu: (
    <Disclosure required={false} slug="partners-widgets.student-loan-refi.disclaimer.edvestinu" />
  ),
  nelnet: (
    <Disclosure required={false} slug="partners-widgets.student-loan-refi.disclaimer.nelnet-bank" />
  ),
  risla: <Disclosure required={false} slug="partners-widgets.student-loan-refi.disclaimer.risla" />,
  cordiagrad: (
    <Disclosure required={false} slug="partners-widgets.student-loan-refi.disclaimer.cordiagrad" />
  ),
  isl: <Disclosure required={false} slug="partners-widgets.student-loan-refi.disclaimer.isl" />,
  lendkey: (
    <Disclosure required={false} slug="partners-widgets.student-loan-refi.disclaimer.lendkey" />
  ),
  brazos: (
    <Disclosure required={false} slug="partners-widgets.student-loan-refi.disclaimer.brazos" />
  ),
  sofi: <Disclosure required={false} slug="partners-widgets.student-loan-refi.disclaimer.sofi" />,
  earnest: (
    <Disclosure required={false} slug="partners-widgets.student-loan-refi.disclaimer.earnest" />
  ),
}

export default disclaimers
